module.exports = __webpack_public_path__ + "img/stereo-10-brisbane.654e5844.png";